var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "warning_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#warning_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.284 13.667a.552.552 0 0 1-.517-.3.582.582 0 0 1 0-.6l5.7-9.867c.122-.2.3-.3.533-.3.234 0 .411.1.534.3l5.7 9.867c.11.2.11.4 0 .6-.111.2-.284.3-.517.3H2.284ZM8 6.8a.485.485 0 0 0-.5.5v2.333c0 .134.048.25.142.35.094.1.214.15.358.15.145 0 .264-.05.359-.15a.494.494 0 0 0 .141-.35V7.3a.487.487 0 0 0-.141-.359.487.487 0 0 0-.359-.14Zm0 5.067a.52.52 0 0 0 .384-.15c.1-.1.15-.228.15-.384a.52.52 0 0 0-.15-.383A.52.52 0 0 0 8 10.8a.52.52 0 0 0-.383.15.52.52 0 0 0-.15.383c0 .156.05.284.15.384.1.1.228.15.383.15Zm-5.033.8h10.067L8 4l-5.033 8.667Z",
    fill: "#fff"
  }))));
};

export default SvgWarning;